import { useEffect, useState, useCallback } from "react";
import api from "../api";
import { Modal } from "./ui";

const ST = {
  DELIVERED: { ico: "✅", lbl: "consegnato", col: "#22a35a" },
  NOT_DELIVERED: { ico: "❌", lbl: "non consegnato", col: "#f87171" },
  ERROR: { ico: "❌", lbl: "errore", col: "#f87171" },
  SENT: { ico: "🕓", lbl: "in consegna", col: "#f59e0b" },
  EMAIL: { ico: "✉️", lbl: "via email", col: "#7dd3fc" },
};
const st = (s) => ST[s] || { ico: "🕓", lbl: (s || "in corso").toLowerCase(), col: "#94a3b8" };

export default function ReviewRecovery({ onClose }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState("");

  const load = useCallback(() => {
    api.get("/appointments/reviews/panel", { noCache: true }).then((r) => setData(r.data)).catch(() => setData({ backlog: [], sent: [] }));
  }, []);
  useEffect(() => { load(); }, [load]);

  const sendNow = async (a) => {
    if (!window.confirm(`Invio ORA la richiesta di recensione a ${a.name} (${a.contatto})?`)) return;
    setBusy(a.id);
    try {
      const r = await api.post(`/appointments/${a.id}/send-review`);
      alert(`✅ Richiesta inviata a ${r.data.ok} destinatar${r.data.ok === 1 ? "io" : "i"}.`);
      load();
    } catch (e) { alert(e?.response?.data?.detail || e.message); }
    setBusy("");
  };
  const refresh = async () => {
    setBusy("refresh");
    try {
      const r = await api.post("/appointments/reviews/refresh-delivery");
      load();
      if (!r.data.checked) alert("Nessun SMS in attesa di verifica.");
    } catch (e) { alert(e?.response?.data?.detail || e.message); }
    setBusy("");
  };
  const fmt = (d) => (d ? d.split("-").reverse().join("/") : "—");

  return (
    <Modal title="🌟 Recensioni — arretrate e consegna SMS" onClose={onClose} wide>
      {!data ? <p className="muted">Carico…</p> : (
        <div style={{ maxHeight: "62vh", overflowY: "auto" }}>
          <h4 style={{ margin: "4px 0 6px" }}>📮 Arretrate da inviare ({data.backlog.length})</h4>
          {data.backlog.length === 0 ? <p className="muted" style={{ fontSize: 13 }} data-testid="reviews-backlog-empty">Nessuna richiesta saltata negli ultimi 30 giorni. 👌</p> : (
            <p className="muted" style={{ fontSize: 12.5, margin: "0 0 8px" }}>Appuntamenti conclusi la cui richiesta non è mai partita (es. nei giorni dei crash): inviala ora con un clic.</p>
          )}
          {data.backlog.map((a) => (
            <div key={a.id} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13, padding: "4px 0", flexWrap: "wrap" }} data-testid={`review-backlog-${a.id}`}>
              <span><strong>{a.name}</strong> · {fmt(a.date)} {a.time} · <span className="muted">{a.contatto}</span></span>
              <button className="btn sm primary" onClick={() => sendNow(a)} disabled={busy === a.id} data-testid={`review-send-${a.id}`}>
                {busy === a.id ? "Invio…" : "⭐ Invia ora"}
              </button>
            </div>
          ))}

          <div style={{ display: "flex", alignItems: "center", gap: 10, margin: "18px 0 6px" }}>
            <h4 style={{ margin: 0 }}>📲 Consegna delle richieste inviate ({data.sent.length})</h4>
            <button className="btn sm" onClick={refresh} disabled={busy === "refresh"} data-testid="reviews-refresh-delivery">
              {busy === "refresh" ? "Verifico…" : "🔄 Verifica consegna"}
            </button>
          </div>
          {data.sent.length === 0 && <p className="muted" style={{ fontSize: 13 }}>Il report di consegna vale per le richieste inviate da oggi in poi.</p>}
          {data.sent.map((a) => (
            <div key={a.id} style={{ fontSize: 13, padding: "4px 0" }} data-testid={`review-sent-${a.id}`}>
              <strong>{a.name}</strong> · {fmt(a.date)} {a.time}
              {(a.delivery || []).map((d, i) => {
                const s = st(d.status);
                return (
                  <span key={i} style={{ marginLeft: 10, color: s.col }}>
                    {s.ico} {d.to} — {s.lbl}{d.delivery_date ? ` (${new Date(d.delivery_date).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })})` : ""}
                  </span>
                );
              })}
            </div>
          ))}
        </div>
      )}
      <div className="modal-actions">
        <button className="btn primary" onClick={onClose}>Chiudi</button>
      </div>
    </Modal>
  );
}
